import { useContext, useState } from 'react'

// context
import { AppContext } from '../../../App'

// components
import FileUploader from '../../file-uploader/file-uploader'
import Field from '../../forms/field/field'
import StepCard from '../../step-card/step-card'

// styles
import styles from './upload-page.module.scss'

const UploadPage = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const [claimNumber, setClaimNumber] = useState(
		appContext?.claimNumber || ''
	)

	return (
		<StepCard stepTitle="Upload Photo" className={styles.card}>
			<div
				className={[styles.wrapper, 'animate-appear'].join(' ').trim()}
			>
				<div className={styles.form}>
					<Field
						className={styles.claimField}
						type="text"
						placeholder="Add a claim number"
						label="Claim Number"
						value={claimNumber}
						onChange={(e) => {
							setClaimNumber(e.currentTarget.value)
							appContext?.setClaimNumber(e.currentTarget.value)
						}}
					/>
					<FileUploader />
				</div>
			</div>
		</StepCard>
	)
}
export default UploadPage
